import { createEvent } from 'effector';
import { redirect } from 'atomic-router';

import { employeeRoute, teamRoute } from 'shared/routes';
import { definitions } from 'shared/types/APISchema';
import { factory } from 'entities/searchEmployees';

export const searchPanelOpened = createEvent<boolean>();

const userSelected = createEvent<definitions['EmployeeSearch']>();
const teamSelected = createEvent<definitions['MinTeam']>();

export const searchModel = factory.createModel({
  onSelectUser: userSelected,
  openSearchPanel: searchPanelOpened,
  onSelectTeam: teamSelected,
});

redirect({
  clock: userSelected,
  params: (payload) => ({ id: payload.id.toString() }),
  route: employeeRoute,
});

redirect({
  clock: teamSelected,
  params: (payload) => ({ id: payload.id.toString() }),
  route: teamRoute,
});
